import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  sortButton: {
    paddingRight: 0,
    paddingLeft: 0,
    marginLeft: 4,
  },
  activeSort: {
    color: '#FF5246',
  },
});

const BeneficiosSortButton = ({ column, sortState, onSort }) => {
  const classes = useStyles();

  const isActive = sortState && column in sortState;
  const currentDirection = isActive ? sortState[column] : 'ASC';

  const handleSort = () => {
    const newDirection = currentDirection === 'ASC' ? 'DESC' : 'ASC';
    onSort({ [column]: newDirection });
  };

  const tooltipTitle = `Ordenar por ${column} em ordem ${currentDirection === 'ASC' ? 'descendente' : 'ascendente'}`;

  return (
    <Tooltip title={tooltipTitle} placement="top">
      <IconButton
        onClick={handleSort}
        className={`${classes.sortButton} ${isActive ? classes.activeSort : ''}`}
        size="small"
      >
        {currentDirection === 'ASC' ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </IconButton>
    </Tooltip>
  );
};

BeneficiosSortButton.propTypes = {
  column: PropTypes.string.isRequired,
  sortState: PropTypes.object,
  onSort: PropTypes.func.isRequired,
};

BeneficiosSortButton.defaultProps = {
  sortState: {},
};

export default BeneficiosSortButton;
